export default class hr {
	static translations = {
		labels: {
			rowsPerPage: "Redaka po stranici:",
			all: "Svi",
			noResults: "Nema rezultata.",
			of: "od",
			selectItem: "Odaberite opciju",
			from: "od",
			to: "do",
			uploadInProgress: "Upload u tijeku.",
			dragdrop: "Povucite datoteke ovdje",
			dragdropSingle: "Povucite datoteku ovdje",
			yes: "Da",
			no: "Ne",
			opportunityId: "Opportunity ID",
			languageDescription: "opis",
			title: "Naslov",
			description: "Opis",
			equipment: "Oprema",
			locationDescription: "Opis lokacije",
			additionalInformation: "Ostale informacije",
			footerForWeb: "Footer za naš web",
			advertisedPrice: "*Oglašena cijena (ukupna cijena u EUR)",
			webCategories: "Kategorije za naš web",
			prominentRealEstate: "Istaknute nekretnine",
			specialOffers: "Posebne ponude",
			reducedRealEstatePrices: "Snižene cijene nekretnina",
			topThreeApartments: "Apartmani top tri",
			topThreeHouses: "Kuće top tri",
			topThreeFlats: "Stanovi top tri",
			topThreePlots: "Zemljišta top tri",
			newRealEsateOffers: "Novo u ponudi nekretnina",
			uploadFiles: "Učitaj datoteke",
			noFilesUploaded: "Nema učitanih datoteka",
			location: "Lokacija",
			partners: "Partneri",
			syncPortals: "Portali za sinkronizaciju",
			videoUrl: "Video URL",
			luxury: "Luksuzna nekretnina",
			first_row: "Prvi red do mora",
			second_row: "Drugi red do mora",
			seaview: "Pogled na more",
			sea_distance: "Udaljenost od mora",
			center_distance: "Udaljenost od centra",
			sea_approach: "Prilaz moru",
			orientation: "Orijentacija",
			hidden_info: "Ne prikazuje se točna lokacija nekretnine",
			videocall: "Razgledavanje putem video poziva",
			exchanges: "Moguće zamjene",
			appartment_type: "Tip stana",
			house_type: "Tip kuće",
			space_purpose: "Namjena",
			ground_type: "Tip zemljišta",
			level_no: "Broj etaža",
			position: "Pozicija",
			ground_purpose: "Namjena",
			rooms_no: "Broj soba",
			room_no: "Broj prostorija",
			bathrooms_with_no: "Broj kupaonica s wc-om",
			area: "Površina zemljišta (u m2)",
			bathrooms_without_no: "Broj kupaonica bez wc-a",
			ground_length: "Dužina",
			toilet_no: "Broj wc-a",
			ground_width: "Širina",
			house_build_type: "Vrsta kuće (gradnja)",
			floor: "Kat",
			total_floors: "Ukupni broj katova u zgradi",
			ground_area: "Površina zemljišta (u m2)",
			units_no: "Broj stambenih jedinica u zgradi",
			living_area: "Stambena površina u m2",
			nett_area: "Neto površina (u m2)",
			year_built: "Godina izgradnje",
			build_type: "Vrsta izgradnje",
			tifacade: "Ti fasada",
			facade_width: "Debljina fasade",
			roof_state: "Stanje krovišta",
			roof_type: "Vrsta krovišta",
			roof_build_type: "Vrsta gradnje krova",
			roof_isolation: "Izolacija krova",
			windows_type: "Prozori (materijal)",
			windows_equipment: "Prozori (oprema)",
			floors: "Podovi",
			approach_material: "Prilazni put (materijal)",
			approach_type: "Prilazni put (tip)",
			renovation_year: "Godina zadnje renovacije",
			infrastructure: "Infrastruktura",
			object_data: "Podaci o objektu",
			shape: "Oblik zemljišta",
			septic_tank_volume: "Septička jama m3",
			septic_tank: "Septička jama",
			heating: "Grijanje",
			additional_info: "Dodatne informacije",
			air_conditioning: "Klima uređaj",
			ground_permits_and_confirmations: "Dozvole i potvrde",
			energy_class: "Energetski razred",
			alternative_energy: "Alternativni izvori energije",
			permits_and_confirmations: "Dozvole i potvrde",
			lodge_terrace: "Lođa/terasa",
			furniture_state: "Namještenost i stanje",
			other_objects: "Ostali objekti i površine",
			pool_details: "Bazen detalji",
			pool_size: "Površina bazena u m2",
			parking_type: "Vrsta parkiranja",
			parking_spaces: "Broj vlastitih parkirnih mjesta",
			functionalities: "Funkcionalnosti i karakteristike",
			tourism_income: "Prihodi od turizma",
			reserve: "Pričuva",
			reserve_amount: "Iznos",
			realestateLocation: "Lokacija nekretnine",
			realestateBasicInfo: "Osnovni podaci",
			realestateAdditionalInfo: "Dodatni podaci",
			reports: "Izvještaji",
			reportsContacts: "Kontrola kontakata",
			featuresGeneral: "Općenite značajke",
			featuresSpecific: "Specifične značajke",
			contactId: 'ID kontakta',
			codebooks: 'Šifrarnici',
			codebooksHeating: 'Šifrarnik grijanja',
			reportsRealestate: "Nekretnine",
			partnerEmailAddress: "E-mail adresa partnera",
			reportsOpportunityQuestionnaire: "Općenito pretraživanje Opportunity-a (Upitnik)",
			reportsOpportunityBuyer: "Općenito pretraživanje Opportunity-a (Kupac)",
			price: "Cijena",
			areaReport: "Kvadratura",
			elevator: "Lift",
			garden: "Dvorište/Vrt",
			pool: "Bazen",
			selectAll: "Odaberi sve",
			reportBrochuresSent: "Brošura poslana",
			contactEmailAddress: "E-mail adrese kontakta",
			contactEmailAddress: "E-mail adrese kontakta",
			salesStage: "Status",
			longitude: "Geografska dužina",
			latitude: "Geografska širina",
			indomioLocation: "Indomio lokacija",
			njuskaloLocation: "Njuškalo lokacija",
			databaseOutdated: "Baza podataka je zastarjela. Pokrenite ažuriranje pritiskom na tipku na dnu izbornika.",
			reportsRealestateAnalysis: "Analiza nekretnina",
			reportsContactsAnalysis: "Analiza klijenata",
			reportsPartners: "Partneri",
			reportsPartner: "Partner",
			reportsPartnersRealestate: "Nekretnine kod partnerskih agencija",
			realestateDownloadTime: "Datum preuzimanja nekretnine",
			reportsWaitTime: "Zbog specifičnosti strukture podataka, dohvaćanje informacija za ovo izvješće može potrajati nekoliko trenutaka.",
			codebooksAdditionalInfo: "Ostale informacije",
			areaBusiness: "Površina (u m2)",
			penthouse: "Penthouse",
		},
		emailTemplates: {
			priceChange: "Promjena cijene",
			removeFromOffer: "Micanje iz ponude"
		},
		modules: {
			partners: "Partneri",
			opportunities: "Opportunities",
			locations: "Lokacije",
			languages: "Jezici",
			newLanguage: "Novi jezik",
			newLocation: "Nova lokacija",
			newPartner: "Novi partner",
			opportunity: "Prilika",
			manualPortals: "Portali",
			newManualPortal: "Novi portal",
			history: "Povijest",
			reports: "Izvještaji",
			contacts: "Kontakti",
			codebooks: "Šifrarnici",
			syncDatabase: "Sinkroniziraj bazu",
			lastSync: "Last sync",
			automaticPortals: "Portali za sinkronizaciju"
		},
		fields: {
			firstName: "Ime",
			lastName: "Prezime",
			email: "E-mail",
			password: "Lozinka",
			rememberMe: "Zapamti me",
			passwordChange: "Promjena lozinke",
			oldPassword: "Stara lozinka",
			newPassword: "Nova lozinka",
			newPasswordConfirmation: "Ponovljena nova lozinka",
			active: "Aktivan",
			role: "Uloga",
			name: "Naziv",
			county: "Županija",
			city: "Mjesto",
			neighbourhood: "Naselje",
			username: "Username",
			mainLanguage: "Glavni jezik",
			otherLanguages: "Ostali jezici",
			partner: "Partner",
			language: "Jezik",
			dateOfLastDownload: "Datum zadnjeg preuzimanja",
			publish: "Objavi",
			website: "Portal",
			status: "Status",
			dateOfPublish: "Datum objave",
			sync: "Sinkroniziraj",
			userId: "Korisnik",
			vtigerId: "Opportunity",
			time: "Vrijeme promjene",
			field: "Polje",
			oldValue: "Stara vrijednost",
			newValue: "Nova vrijednost",
			phoneNo: "Telefon/Mobitel",
			type: "Vrsta",
			telephoneNo: "Telefon",
			mobilePhoneNo: "Mobitel",
			realestateType: "Tip nekretnine",
			roomsNo: "Broj soba",
			priceFrom: "Cijena od",
			priceTo: "Cijena do",
			areaFrom: "Kvadratura od",
			areaTo: "Kvadratura do",
			sea1st: "1. red do mora",
			sea2nd: "2. red do mora",
			seaView: "Pogled na more",
			elevator: "Dizalo",
			garden: "Vrt",
			pool: "Bazen",
			contactId: "ID kontakta",
			realestateId: "Nekretnina ID",
			contactName: "Ime i prezime kontakta",
			code: "Skraćeni naziv",
			template: "Predložak",
			subject: "Naslov",
			body: "Poruka",
			seaBoth: "1. ili 2. red do mora",
			firstAndLastName: "Ime i prezime",
			zipCode: "Poštanski broj",
			country: "Država",
			questionnaire: "Upitnik",
			contactType: "Vrsta",
			communicationLanguage: "Jezik komunikacije",
			vtigerIdContact: "ID",
			seaNone: "Ništa od navedenog",
			recipient: "Primatelj",
			emailTime: "Vrijeme slanja e-maila",
			statusXml: "Status generiranja XML datoteke",
			dateOfXml: "Datum zadnjeg generiranja XML datoteke",
			generateXml: "Generiraj XML datoteku",
			validate: "Validiraj",
			ownerContact: "Vlasnik - Kontakt",
			ownerOrganisation: "Vlasnik - Organizacija",
			totalOfferings: "Broj ukupnih nuđenja",
			totalViews: "Broj ukupnih razgleda",
			totalRecievedOffers: "Broj ukupno primljenih ponuda",
			totalPriceChanges: "Broj promjena cijena",
			dateOfContactStart: "Nekretnina u ponudi od",
			dateOfContactExpiration: "Datum isteka ugovora",
			salesStage: "Status ugovora",
			buildStage: "Status nekretnine",
			expectedFinishDate: "Predviđen datum završetka izgradnje",
			pairing: "Izvršeno uparivanje",
			completeDocumentation: "Kompletirana dokumentacija",
			firstContact: "Prvi kontakt",
			lastContact: "Zadnji kontakt",
			leadSource: "Izvor leada",
			priceReductionNotified: "Obavijest o sniženju",
			totalOfferedRealestate: "Ukupno ponuđenih nekretnina",
			totalViewsCompleted: "Broj odrađenih razgleda",
			totalViewsCanceled: "Broj otkazanih razgleda",
			budget: "Budžet",
			typeOfRealestate: "Tražene nekretnine",
			assignedTo: "Odgovorna osoba",
			leftReview: "Ostavili recenziju",
			lookingForRealestate: "Traže nekretninu",
			boughtOurRealestate: "Kupili našu nekretninu",
			clientNo: "Broj Klijenata",
			buyersNo: "Broj kupaca",
			realeastateNo: "Broj nekretnina",
			totalOffersRecieved: "Dano ponuda",
		},
		alerts: {
			removalQuestion: "Jeste li sigurni da želite ukloniti ovaj zapis?",
			fileDeletionQuestion: "Jeste li sigurni da želite izbrisati ovu datoteku??",
			emailMissing: "Niste upisali e-mail.",
			emailFailFormat: "E-mail nije u ispravnom formatu.",
			passwordMissing: "Niste upisali lozinku.",
			passwordFailConfirmation: "Lozinke se ne podudaraju.",
			passwordResetSuccess: "Nova lozinka je poslana na e-mail adresu.",
			passwordResetFail: "Nije pronađen korisnik s unesenom e-mail adresom.",
			basicUpdate: "Promjene spremljene.",
			basicDelete: "Zapis izbrisan.",
			basicAdd: "Zapis dodan.",
			basicError: "Došlo je do greške na poslužitelju.",
			fileSize: "Datoteka je prevelika. Maksimalna veličina datoteke je 15MB.",
			fileSizeMultiple: "Datoteka %filename% je prevelika. Maksimalna veličina datoteke je 15MB.",
			oldPasswordFail: "Stara lozinka nije ispravna.",
			passwordLength: "Lozinka mora imati minimalno 8 znakova.",
			loginFail: "Neispravni podaci.",
			logoutQuestion: "Jeste li sigurni da se želite odjaviti?",
			fieldError: "Ovo polje je obavezno.",
			leaveQuestion: "Jeste li sigurni da želite otići bez spremanja?",
			maxFiles: "Maksimalnih broj dokumenata koje možete uploadati je 15.",
			locationExists: "Lokacija sa tom županijom, mjestom i naseljem već postoji.",
			partnerExists: "Partner s tom e-mail adresom ili usernameom već postoji.",
			noPartnersSelected: "Nije odabran niti jedan partner",
			emailNotificationsSent: "Email obavijesti poslane",
			manualPortalsUpdate: "Ažuriran status ručno unesenih portala",
			emailSendQuestion: "Jeste li sigurni da želite poslati ovu poruku?",
			emailCancelQuestion: "Jeste li sigurni da želite odustati od slanja ove poruke?",
			priceError: "'Cijena do' ne smije biti manja od 'Cijena od'",
			areaError: "'Kvadratura do' ne smije biti manja od 'Kvadratura od'",
			noOpportunitiesSelected: "Nije odabran niti jedan opportunity",
			reportEmailsSent: "Brošure poslane",
			noContactsSelected: "Nije odabran niti jedan kontakt",
			sendBrochuresConfirmation: "Jeste li sigurni da želite poslati brošure?",
			emailSent: "Poruka poslana;",
			updateDatabaseConfirmation1: "Jeste li sigurni da želite ažurirati bazu?",
			updateDatabaseConfirmation2: "Ova akcija bi mogla potrajati nekoliko minuta.",
			noRecipients: "Sve adrese primatelja su uklonjene.",
			verifyLoadImages1: "Jeste li sigurni da želite učitati slike s drugog opportunityija?",
			verifyLoadImages2: "Ova akcija će obrisati sve postojeće slike!",
			verifyLoadFeatures1: "Jeste li sigurni da želite učitati značajke s drugog opportunityija?",
			verifyLoadFeatures2: "Ova akcija će obrisati sve postojeće značajke!",
			noOpportunitySelected: "Morate odabrati opportunity",
		},
		buttons: {
			login: "Prijava",
			logout: "Odjava",
			profile: "Moj profil",
			new: "Novo",
			save: "Spremi",
			saveAndClose: "Spremi i zatvori",
			add: "Dodaj",
			cancel: "Odustani",
			yes: "Da",
			no: "Ne",
			ok: "OK",
			all: "Svi",
			delete: "Briši",
			back: "Nazad",
			forgottenPassword: "Zaboravljena lozinka?",
			send: "Pošalji",
			addUserAccount: "Dodaj korisnički račun",
			search: "Pretraga",
			emailPartners: "Email obavijest označenim partnerima",
			details: "Detaljno",
			syncAll: "Sikroniziraj sve",
			match: "Upari",
			vtigerLink: "Otvori u vtigeru",
			changeManualPortalStatus: "Ažuriraj statuse ručno unesenih portala",
			contactReport: "Kontrola kontakata",
			codebooksHeating: "Grijanje",
			realestateReport: "Nekretnine",
			opportunityQuestionnaireReport: "Opportunity - Upitnik",
			opportunityBuyerReport: "Opportunity - Kupac",
			checkQuestionnaire: "Provjeri upitnik",
			reportSendEmails: "Napravi brošuru",
			checkOpportunity: "Provjeri opportunity",
			realestateAnalysisReport: "Analiza nekretnina",
			contactsAnalysisReport: "Analiza klijenata",
			partnersReport: "Partneri",
			partnersRealestateReport: "Nekretnine kod partnerskih agencija",
			deleteFilters: "Obriši filtere",
			fetchData: "Dohvati podatke",
			additionalInfo: "Ostale informacije",
			clear: "Očisti izbor",
			copyImages: "Učitaj slike",
			copyFeatures: "Učitaj značajke",
			load: "Učitaj",
		},
		tooltips: {
			logout: "Odjava",
			excel: "Excel izvoz",
			filter: "Filter",
			openInNewTab: "Otvori u novom tabu",
			delete: "Izbriši",
			uploadFile: "Dodaj datoteku",
			removeFile: "Izbriši datoteku",
			add: "Dodaj",
			saveBeforeMatch: "Potrebno je spremiti promjene prije uparivanja",
		},
		tabs: {
			ad: "Oglas",
			media: "Slike",
			posts: "Objave",
			details: "Detalji",
			features: "Značajke",
			questionnaires: "Upitnici",
			mediaWithLogo: "Slike s logotipom",
			opportunityHistory: "Opportunities",
			emailHistory: "Emails",
		}
	}
}

